import classnames from 'classnames/bind'

import { TCheckProps } from 'components/form-elements/Check'

import s from './CheckLarge.module.scss'

const c = classnames.bind(s)

type CheckLargeProps = TCheckProps & {
  onButtonClick?: () => void
  buttonText?: string
}

export const CheckLarge = ({
  label,
  name,
  id,
  value,
  checked,
  defaultChecked,
  disabled,
  className,
  inputType = 'checkbox',
  onChange,
  onButtonClick,
  buttonText,
  ...props
}: CheckLargeProps) => {
  const hasButton = !!buttonText && !!onButtonClick
  return (
    <div
      className={c(s.checkLarge, inputType, className, { disabled, hasButton })}
    >
      <label className={s.checkLarge__label}>
        <input
          className={s.checkLarge__input}
          type={inputType}
          name={name}
          value={value}
          id={id}
          defaultChecked={defaultChecked}
          checked={checked}
          tabIndex={0}
          disabled={disabled}
          onChange={onChange}
          {...props}
        />
        <span className={s.checkLarge__labelText}>{label}</span>

        {inputType === 'checkbox' && (
          <svg
            className={s.checkLarge__check}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 10"
          >
            <path
              stroke="#320564"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M1.5 5.8 4.643 9 12.5 1"
            />
          </svg>
        )}
      </label>

      {buttonText && onButtonClick && (
        <button
          className={s.checkLarge__button}
          onClick={() => onButtonClick()}
        >
          {buttonText}
        </button>
      )}
    </div>
  )
}
